import { useLocation } from 'react-router-dom';

export const useModeID = () => {
  const location = useLocation();
  const { state } = location;
  const { screenMode = null, userId = null } = state || {};

  return { screenMode, userId };
};
